export const cultivatorDesktopSlots = [
  'cultivator-desktop-alexa-mwac',
  'cultivator-desktop-alexa-bies',
  'cultivator-desktop-alexa-mwac-fallback',
  'cultivator-desktop-alexa-bies-fallback',
  'cultivator-desktop-healthcare-mwac',
  'cultivator-desktop-healthcare-mwac-fallback',
  'cultivator-desktop-video-mwac',
  'cultivator-desktop-video-bies',
  'cultivator-desktop-video-mwac-fallback',
  'cultivator-desktop-video-bies-fallback',
  'cultivator-desktop-brand-truth-mwac',
  'cultivator-desktop-brand-truth-mwac-fallback',
  'cultivator-desktop-events-mwac',
  'cultivator-desktop-events-mwac-fallback',
  'cultivator-desktop-grocery-bies',
  'cultivator-desktop-grocery-bies-fallback',
  'cultivator-desktop-home-bies',
  'cultivator-desktop-home-bies-fallback',
  'cultivator-desktop-softlines-bies',
  'cultivator-desktop-softlines-bies-fallback',
  'cultivator-desktop-music-bies',
  'cultivator-desktop-music-bies-fallback',
  'cultivator-desktop-prime-bies',
  'cultivator-desktop-prime-bies-fallback',
  'cultivator-desktop-other-devices-mwac',
  'cultivator-desktop-other-devices-bies',
  'cultivator-desktop-other-devices-mwac-fallback',
  'cultivator-desktop-other-devices-bies-fallback',
  'cultivator-desktop-3p-takeover',
  'cultivator-desktop-audible-bies',
  'cultivator-desktop-audible-bies-fallback',
  'cultivator-desktop-reading-bies',
  'cultivator-desktop-reading-bies-fallback',
  'cultivator-desktop-credit-bies',
  'cultivator-desktop-credit-bies-fallback',
  'cultivator-desktop-gaming-bies',
  'cultivator-desktop-gaming-bies-fallback',
  'cultivator-desktop-subscribesave-bies',
  'cultivator-desktop-subscribesave-bies-fallback',
  'cultivator-desktop-privatebrands-bies',
  'cultivator-desktop-privatebrands-bies-fallback',
  'cultivator-desktop-criticals-mwac',
  'cultivator-desktop-criticals-mwac-fallback',
  'cultivator-desktop-tsto-n',
  'cultivator-desktop-tsto-2',
  'cultivator-desktop-tsto',
];

export const cultivatorMobileSlots = [
  'cultivator-mobile-alexa-mwac',
  'cultivator-mobile-alexa-bies',
  'cultivator-mobile-alexa-mwac-fallback',
  'cultivator-mobile-alexa-bies-fallback',
  'cultivator-mobile-healthcare-mwac',
  'cultivator-mobile-healthcare-mwac-fallback',
  'cultivator-mobile-video-mwac',
  'cultivator-mobile-video-bies',
  'cultivator-mobile-video-mwac-fallback',
  'cultivator-mobile-video-bies-fallback',
  'cultivator-mobile-brand-truth-mwac',
  'cultivator-mobile-brand-truth-mwac-fallback',
  'cultivator-mobile-events-mwac',
  'cultivator-mobile-events-mwac-fallback',
  'cultivator-mobile-grocery-bies',
  'cultivator-mobile-grocery-bies-fallback',
  'cultivator-mobile-home-bies',
  'cultivator-mobile-home-bies-fallback',
  'cultivator-mobile-softlines-bies',
  'cultivator-mobile-softlines-bies-fallback',
  'cultivator-mobile-music-bies',
  'cultivator-mobile-music-bies-fallback',
  'cultivator-mobile-prime-bies',
  'cultivator-mobile-prime-bies-fallback',
  'cultivator-mobile-other-devices-mwac',
  'cultivator-mobile-other-devices-bies',
  'cultivator-mobile-other-devices-mwac-fallback',
  'cultivator-mobile-other-devices-bies-fallback',
  'cultivator-mobile-3p-takeover',
  'cultivator-mobile-audible-bies',
  'cultivator-mobile-audible-bies-fallback',
  'cultivator-mobile-reading-bies',
  'cultivator-mobile-reading-bies-fallback',
  'cultivator-mobile-credit-bies',
  'cultivator-mobile-credit-bies-fallback',
  'cultivator-mobile-gaming-bies',
  'cultivator-mobile-gaming-bies-fallback',
  'cultivator-mobile-subscribesave-bies',
  'cultivator-mobile-subscribesave-bies-fallback',
  'cultivator-mobile-privatebrands-bies',
  'cultivator-mobile-privatebrands-bies-fallback',
  'cultivator-mobile-criticals-mwac',
  'cultivator-mobile-criticals-mwac-fallback',
  'cultivator-mobile-tsto-n',
  'cultivator-mobile-tsto-2',
  'cultivator-mobile-tsto',
];

export const gatewaySlots = {
  gatewayDesktopKindleSecondarySlotsWithSov: [
    'desktop-tall-hero-kindle-A',
    'desktop-tall-hero-kindle-B',
    'desktop-tall-hero-kindle-B-ALF',
    'desktop-tall-hero-kindle-B-AUCC',
    'desktop-tall-hero-kindle-B-DASH',
    'desktop-tall-hero-kindle-B-EINK',
    'desktop-tall-hero-kindle-B-FSN',
    'desktop-tall-hero-kindle-B-HA',
    'desktop-tall-hero-kindle-B-INSTALL',
    'desktop-tall-hero-kindle-B-MAB',
    'desktop-tall-hero-kindle-B-SMP',
    'desktop-tall-hero-kindle-B-TAB',
    'desktop-tall-hero-kindle-B-VICC',
    ...cultivatorDesktopSlots,
  ],
  gatewayDesktopKindleSlotsWithoutSov: [
    'desktop-tall-hero-kindle-A',
    'desktop-tall-hero-kindle-B',
    'desktop-tall-hero-J',
    'desktop-tall-hero-softlines',
    ...cultivatorDesktopSlots,
  ],
  gatewayDesktopKindleSlotsWithSov: [
    'desktop-tall-hero-A',
    'desktop-tall-hero-B',
    'desktop-tall-hero-D',
    'desktop-tall-hero-J',
    'desktop-tall-hero-kindle-A',
    'desktop-tall-hero-kindle-A-ALF',
    'desktop-tall-hero-kindle-A-AUCC',
    'desktop-tall-hero-kindle-A-DASH',
    'desktop-tall-hero-kindle-A-EINK',
    'desktop-tall-hero-kindle-A-FSN',
    'desktop-tall-hero-kindle-A-HA',
    'desktop-tall-hero-kindle-A-INSTALL',
    'desktop-tall-hero-kindle-A-MAB',
    'desktop-tall-hero-kindle-A-SMP',
    'desktop-tall-hero-kindle-A-TAB',
    'desktop-tall-hero-kindle-A-VICC',
    'desktop-tall-hero-kindle-B',
    ...cultivatorDesktopSlots,
  ],
  gatewayMobileDashboardSlots: [
    'md-grid-1',
    'md-grid-2',
    'md-grid-3',
    'md-grid-4',
    'md-grid-5',
    'md-grid-6',
    'md-grid-7',
    'md-grid-8',
    'md-grid-9',
    'md-grid-10',
    'md-grid-11',
    'md-grid-12',
    'md-grid-13',
    'md-grid-14',
    'md-grid-15',
    ...cultivatorMobileSlots,
  ],
  gatewayMobileDefaultSlots: [
    'grid-1',
    'grid-mso-billboard-ctr',
    'mobile-hero-slide-3',
    ...cultivatorMobileSlots,
  ],
  gatewayMobileSCCAndFPCSlots: [
    'wd-shoppable-mso',
    'wd-shoppable-1',
    'wd-shoppable-2',
    'wd-shoppable-3',
    'wd-shoppable-4',
    'wd-shoppable-5',
    'wd-shoppable-6',
    'wd-shoppable-7',
    'wd-shoppable-8',
    'wd-shoppable-9',
    'wd-shoppable-10',
    'wd-shoppable-11',
    'wd-shoppable-12',
    'wd-strategic-mso',
    'wd-strategic-1',
    'wd-strategic-2',
    'wd-ad-mso',
    'wd-ad-1',
    'wd-priority-mso',
  ],
  gatewayMobileSlotsWithSov: [
    'grid-1',
    'grid-1-ALF',
    'grid-1-AUCC',
    'grid-1-DASH',
    'grid-1-EINK',
    'grid-1-FSN',
    'grid-1-HA',
    'grid-1-INSTALL',
    'grid-1-MAB',
    'grid-1-SMP',
    'grid-1-TAB',
    'grid-1-VICC',
    'grid-mso-billboard-ctr',
    'mobile-herofader-1',
    'mobile-herofader-2',
    'mobile-herofader-4',
    ...cultivatorMobileSlots,
  ],
  gatewayMobileTallHeroSlots: [
    'mobile-herofader-takeover',
    'mobile-herofader-events',
    'mobile-herofader-1',
    'mobile-herofader-2',
    'mobile-herofader-3',
    'mobile-herofader-4',
    'mobile-herofader-5',
    'mobile-herofader-6',
    'mobile-herofader-7',
    'mobile-herofader-8',
  ],
};

export const deviceTypeSlotOptions = [
  'Desktop',
  'Tablet',
  'Desktop & Tablet',
];
